export const SDK_VERSION = '6.13.1';
